import { render, staticRenderFns } from "./AddEditPeople.vue?vue&type=template&id=e2259dea&"
import script from "./AddEditPeople.vue?vue&type=script&lang=js&"
export * from "./AddEditPeople.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports